import { Flex, Box, Image, Spinner, useColorMode } from "@chakra-ui/react";
import LazyLoad from "react-lazyload";
import { useSelector } from "react-redux";
import getImageSrc from "src/utils/getImageSrc";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { usePurchaseContext } from "src/modules/purchase/PurchaseContext";
import {
  lightDogFileNames,
  darkDogFileNames
} from "src/modules/avatar/dog-file-names";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as LockIcon } from "src/icons/lock.svg";

function getAvatarName(fileName, isDarkMode) {
  return fileName
    .split(isDarkMode ? "dark-" : "light-")[1]
    .split("sleeping-")[1]
    .split(".svg")[0];
}

function getAvatarFileNames(isDarkMode) {
  const themedFileNames = isDarkMode ? darkDogFileNames : lightDogFileNames;
  const restingFileNames = themedFileNames.filter((fileName) =>
    fileName.includes("sleeping")
  );

  // split the array into chunks of 3
  const rows = restingFileNames.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / 3);
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [];
    }
    resultArray[chunkIndex].push(item);
    return resultArray;
  }, []);

  return rows;
}
export default function Appearance({ avatar, handleAvatarStyleUpdate }) {
  const { avatarCustomization } = avatar;
  const { colorMode } = useColorMode();
  const isDarkMode = colorMode === "dark";
  const bg = isDarkMode ? "rgba(255, 255, 255, 0.04)" : "transparent";
  const border = isDarkMode ? "white20" : "black12";
  const avatarFileNames = getAvatarFileNames(isDarkMode);

  const isFreeVersion = useSelector(isFreemium);
  const purchase = usePurchaseContext();
  return (
    <Box
      className="lazyContainer"
      mb="16px"
      position="relative"
      height="317px"
      overflow="auto"
    >
      {avatarFileNames.map((chunkOfNames, i) => {
        return (
          <LazyLoad
            once
            key={i}
            height={104}
            overflow
            scrollContainer=".lazyContainer"
            placeholder={
              <Flex
                alignItems="center"
                justifyContent="center"
                height="104px"
                width="100%"
              >
                <Spinner />
              </Flex>
            }
            throttle={100}
          >
            <Flex>
              {chunkOfNames.map((fileName, i2) => {
                const margin = i2 !== 2;
                const avatarName = getAvatarName(fileName, isDarkMode);
                const isSelected =
                  avatarName === avatarCustomization.breedAppearance;

                const lock = avatarName !== "default" && isFreeVersion;
                return (
                  <Flex
                    mr={margin ? "12px" : "0px"}
                    pt="12px"
                    key={i2}
                    my="8px"
                    width="104px"
                    bg={bg}
                    justifyContent="center"
                    position="relative"
                    height="104px"
                    borderRadius="8px"
                    border="2px solid"
                    borderColor={isSelected ? "primary" : border}
                    onClick={() =>
                      lock
                        ? purchase.open({ content: "editor" })
                        : handleAvatarStyleUpdate({
                            breedAppearance: avatarName
                          })
                    }
                  >
                    {lock && (
                      <Box position="absolute" top="8px" right="8px">
                        <SvgContainer
                          icon={LockIcon}
                          fill="lowEmphasis"
                          size="14px"
                        />
                      </Box>
                    )}
                    <Image
                      height="65px"
                      src={getImageSrc(
                        fileName,
                        {
                          directory: "dogs"
                        },
                        { useTheme: false }
                      )}
                    />
                  </Flex>
                );
              })}
            </Flex>
          </LazyLoad>
        );
      })}
    </Box>
  );
}
